module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d81d8e89d3322c6270e5967a1711403f.png";